import { render } from "./LoginPage.vue?vue&type=template&id=0d8f056e&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=0d8f056e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8f056e"]])

export default __exports__